// extracted by mini-css-extract-plugin
export var features = "features-module--features--yVj9d";
export var featuresNav = "features-module--featuresNav--ct+Cd";
export var featuresIcons = "features-module--featuresIcons--+u5GF";
export var firstSlide = "features-module--firstSlide--I-KQA";
export var featuresSlides = "features-module--featuresSlides--YYpQt";